import type { MultiselectProps } from '@risk-smart/themed-cloudscape-components/multiselect';

/**
 * Above this many rendered options, Cloudscape's PlainList — one mounted Option
 * component per option — stops being viable and virtualScroll has to take over.
 */
export const VIRTUAL_SCROLL_THRESHOLD = 500;

/**
 * Total options Cloudscape will render, counting the members of an option group
 * rather than the group itself.
 *
 * A user picker's top-level array is only ever the section headers built by
 * useGroupAndUserOptions — Recents / Users / Groups / Archived — so `.length`
 * on it is ~4 however many users the tenant has. Sizing virtualScroll off that
 * number left a 13k-user tenant on PlainList, taking 30+ seconds to open the
 * dropdown (CUS-461).
 */
export const countOptions = (
  options: NonNullable<MultiselectProps['options']>
): number =>
  options.reduce((total, option) => {
    if ('options' in option) {
      total += option.options.length;
    }

    return total + 1;
  }, 0);
